import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'
import superjson from 'superjson'
import type { AppRouter } from '@shess/api'

/**
 * Type-only import of the router: the client gets end-to-end inference and
 * none of the server ends up in the bundle.
 */
export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>()

export function createClient() {
  return createTRPCClient<AppRouter>({
    links: [
      httpBatchLink({
        // Same origin in production; proxied by Vite in development.
        url: '/trpc',
        transformer: superjson,
        fetch: (url, options) => fetch(url, { ...options, credentials: 'include' }),
      }),
    ],
  })
}
